import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'
import type { PaymentCheckout } from './types'

export const paymentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReferralOrderPayment: builder.query<PaymentCheckout, { orderId: string }>({
      query: ({ orderId }) => apiEndpoints.referralOrders.payment(orderId),
      providesTags: (_result, _error, { orderId }) => [
        { type: 'ReferralOrderPayment', id: orderId },
      ],
    }),

    createReferralOrderPayment: builder.mutation<PaymentCheckout, { orderId: string }>({
      query: ({ orderId }) => ({
        url: apiEndpoints.referralOrders.payment(orderId),
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, { orderId }) => [
        { type: 'ReferralOrderPayment', id: orderId },
        { type: 'ReferralOrder', id: orderId },
      ],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetReferralOrderPaymentQuery,
  useCreateReferralOrderPaymentMutation,
} = paymentApi
